import Header from "components/common/Header/Header";
import PlanUpgradeGate from "components/common/PlanUpgradeGate/PlanUpgradeGate";
import { LoginContext } from "helpers/LoginContext";
import SideBar from "../../../../components/common/SideBar/SideBarNew";
import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import Breadcrumb from "components/common/Breadcrumb";
import {
  SETTINGS_BREADCRUMB_PAGES,
  SP_SETTING_BREADCRUMB,
} from "Constants/BreadcrumbConstant";
import { BiPlus } from "react-icons/bi";
import {
  canCreatePlanFeature,
  isPlanFeatureAllowed,
} from "helpers/planFeatures";
import { getUser } from "store/selector/auth.selector";
import AddRegion from "./AddRegion";
import RegionTable from "./RegionTable";

const RegionSettings = () => {
  const { sideBarPadding } = useContext(LoginContext);
  const currentUser = useSelector(getUser);
  const regionsAllowed = isPlanFeatureAllowed(currentUser, "regions");
  const canAddRegion = canCreatePlanFeature(currentUser, "regions");
  const [openModal, setOpenModal] = useState(false);
  const [isRefresh, setRefresh] = useState(false);

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <div className='min-h-full'>
      <SideBar />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col`}
      >
        <Header
          title='Region Settings'
          handleClick={() => canAddRegion && setOpenModal(true)}
          btnLabel='Add New Region'
          breadcrumb={
            <Breadcrumb
              pages={SP_SETTING_BREADCRUMB(
                SETTINGS_BREADCRUMB_PAGES.REGION_SETTING
              )}
            />
          }
          icon={<BiPlus />}
          isButton={canAddRegion}
        />
        <section className='w-full sm:px-6 lg:px-8 mt-3'>
          {!regionsAllowed ? (
            <PlanUpgradeGate feature='regions' title='Regions not available on your plan' />
          ) : (
            <>
              {regionsAllowed && !canAddRegion && (
                <div className='mb-4'>
                  <PlanUpgradeGate feature='regions' compact />
                </div>
              )}
              <RegionTable isRefresh={isRefresh} setRefresh={setRefresh} />
            </>
          )}
        </section>
      </div>

      {openModal && (
        <AddRegion
          openModal={openModal}
          handleClose={handleClose}
          setOpenModal={setOpenModal}
          setRefresh={setRefresh}
          isRefresh={isRefresh}
        />
      )}
    </div>
  );
};

export default RegionSettings;
